function resolveBaseUrl() {
  const envUrl = (process.env.REACT_APP_API_URL || '').trim();
  if (envUrl) return envUrl.replace(/\/$/, '');
  return '/api';
}
const BASE_URL = resolveBaseUrl();
function getStoredToken() {
  try {
    return localStorage.getItem('qsniper_token') || '';
  } catch (_) {
    return '';
  }
}
function authHeaders(explicitToken) {
  const t = explicitToken || getStoredToken();
  if (!t) return {};
  return { Authorization: `Bearer ${t}` };
}
async function request(endpoint, options = {}, explicitToken) {
  const url = `${BASE_URL}${endpoint}`;
  const finalUrl =
    window.location.protocol === 'https:' && url.startsWith('http://') ? url.replace('http://', 'https://') : url;
  const res = await fetch(finalUrl, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(explicitToken),
      ...options.headers,
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || err.message || `API Error ${res.status}`);
  }
  return res.json();
}
export const login = (token) => request('/auth/login', { method: 'POST', body: JSON.stringify({ token }) });
export const getSnipers = (userId) => request(`/snipers/${userId}`);
export const createSniper = (data) => request('/snipers', { method: 'POST', body: JSON.stringify(data) });
export const updateSniper = (id, data) => request(`/snipers/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteSniper = (id) => request(`/snipers/${id}`, { method: 'DELETE' });
export const startSniper = (id, userId, token) =>
  request(`/snipers/${id}/start`, { method: 'POST', body: JSON.stringify({ userId, token }) }, token);
export const stopSniper = (id) => request(`/snipers/${id}/stop`, { method: 'POST', body: JSON.stringify({}) });
export const getSniperStatus = (id) => request(`/snipers/${id}/status`);
export const getAlerts = (userId) => request(`/alerts/${userId}`);
export const updateUser = (id, data) => request(`/users/${id}`, { method: 'PUT', body: JSON.stringify(data) });
